<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full-width" no-footer-line>
                <h4 slot="header" class="card-title text-purple">
                {{ $t("app.modules.customers.billing") }}
                </h4>
                <div class="col-md-12">
                    <div class="row">
                        <el-table stripe style="width: 100%" :data="bills">
                            <el-table-column
                            prop="idClienteSAP"
                            :label="this.$t('app.modules.customers.client_code_SAP')"
                            :min-width="280"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="numeroPedidoSAP"
                            :label="this.$t('app.modules.orders.headers.order_number')"
                            :min-width="250"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            prop="fecha"
                            :label="this.$t('app.general.date')"
                            :min-width="250"
                            sortable
                            >
                            </el-table-column>
                            <el-table-column
                            :min-width="100"
                            className="is-center"
                            fixed="right"
                            >
                                <div slot-scope="props" class="table-actions dropdown">
                                    <el-popover
                                    placement="bottom"
                                    width="100"
                                    trigger="click"
                                    :ref="'refOption' + props.$index"
                                    >
                                        <div class="row">
                                            <div class="col-12 options">
                                                <n-button
                                                    @click.native="
                                                    sendBill(
                                                        props.$index,
                                                        props.row,
                                                        'refOption' + props.$index
                                                    )"
                                                    type="primary"
                                                    class="options-button"
                                                    size="sm"
                                                    round
                                                >
                                                    {{ $t("app.general.send") }}
                                                </n-button>
                                            </div>
                                        </div>
                                      <n-button
                                        slot="reference"
                                        size="sm"
                                        icon
                                        style="background-color:white;">
                                        <i class="fa fa-ellipsis-v" style="color:black;"></i>
                                      </n-button>
                                    </el-popover>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                 <div
                    slot="footer"
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                    >
                    <div class="">
                        <p class="card-category">
                        {{ $t("app.pagination.showing") }} {{ from + 1 }}
                        {{ $t("app.pagination.of") }} {{ to }}
                        {{ $t("app.pagination.of") }} {{ total }}
                        {{ $t("app.pagination.records") }}
                        </p>
                    </div>

                    <n-pagination
                        class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </n-pagination>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    components:{},
    data(){
        return{
            item: {},
            bills: [], 
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            }, 
            tableData: [], 
            searchedData: ""
        }
    },
    computed:{ 
        to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
            highBound = this.total;
        }
        return highBound;
        },
        from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
        return this.searchedData.length > 0
            ? this.searchedData.length
            : this.tableData.length;
        }
    },
    async mounted(){
        this.tableData = [];
        this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });
        this.item = this.$route.params
        await this.getBills(this.item.idClienteSAP)
        this.$swal.close();
    },
    methods:{
        async getBills(id){
            var payload = {
                id: id,
                claveIdioma: "",
                usuario: 1
            };

            await this.$http
            .post(route("FacturacionCliente/getFacturasCliente"), payload)
            .then(
                async response => {
                    if (response.body.code === 200){
                        this.bills = response.body.facturas
                    }
                    else {
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            )
            .finally(() => {});

        },
        async sendBill(index, row, ref){
            var payload = {
                id: row.idFactura,
                claveIdioma: "",
                usuario: 0 
            };

            await this.$http
            .post(route("FacturacionCliente/sendFacturasCliente"), payload)
            .then(
                async response => {
                    if (response.body.code === 200){
                        this.notifyMessage("success", this.$t("app.promps.send_success"));
                    }
                    else {
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            )
            .finally(() => {});
        }
    }
}
</script>
